import React, { useState } from 'react'
import './styles.scss'
import { config } from './config'
import { Link } from '@ta-interaktiv/contentbricks'
import { localesInterface } from 'components/main/types'
interface Props {
  sources: string[][]
  locales:localesInterface
}

export const SourceTable = ({ sources,locales }: Props) => {
  const [isOpen, setOpen] = useState<boolean>(false)
  const formatLink = (linkstring: string) => {
    let splitted = linkstring.split('[')
    let label = splitted[0]
    let linktext = splitted[1].split('](')[0]
    let link = splitted[1].split('](')[1].slice(0, -1)
    return (
      <>
        {label} <Link href={link}>{linktext}</Link>
      </>
    )
  }
  return (
    <div className='sourceTable'>
      <div
        className='title'
        onClick={() => {
          setOpen(!isOpen)
        }}
      >
        {locales.sources.title}
        <i className={'angle ' + (isOpen ? ' up ' : ' down ') + ' icon'} />
      </div>
      {isOpen && (
        <table>
          <thead>
            <tr>
              <td>{locales.sources.key[0]}</td>
              <td>{locales.sources.key[1]}</td>
              <td className='date'>{locales.sources.key[2]}</td>
            </tr>
          </thead>
          <tbody>
            {sources.map(source => {
              return (
                <tr>
                  <td className='canton'>{source[0]}</td>
                  <td>{formatLink(source[1])}</td>
                  <td className='date'>{source[2]}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      )}
    </div>
  )
}
